import { useTheme } from '../contexts/ThemeContext';

export default function ThemeWrapper({ children, className = "" }) {
  const { isDark } = useTheme();
  
  return (
    <div className={`${isDark ? 'dark' : ''} ${className}`}>
      {children}
    </div>
  );
}